import type { CreateClientConfig } from '../generated/pap/client/types.gen';

/**
 * Runtime configuration for the generated PAP client.
 *
 * Referenced by the generated `client.gen.ts` via `runtimeConfigPath` in
 * `openapi-ts.config.ts`. This is the hand-written, reviewable place to set the
 * base URL (and any other client defaults). Cross-cutting behaviour such as
 * etag / If-Match handling is registered separately in `./setup.ts`.
 */
export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  baseUrl: '/api/ciam',
});
